<template>
  <div ref="balance" class="balance" :class="{ large }">
    <div class="char-wrapper" v-for="charObj in chars" :key="charObj.idx">
      <transition name="change-item-transition">
        <div :key="charObj.char" class="char">{{ charObj.char }}</div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps({
  balance: {
    type: String,
    required: true
  },
  large: {
    type: Boolean,
    required: false
  }
})

const chars = computed(() => {
  let decimalIndex = props.balance.indexOf('.')
  if (decimalIndex === -1) {
    decimalIndex = props.balance.length
  }
  return props.balance.split('').map((char, index) => ({
    char,
    idx: index - decimalIndex
  }))
})
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@600&display=swap');

.balance {
  display: inline-flex;
  position: relative;
  font-family: 'Roboto Mono', monospace;
  font-style: normal;
  letter-spacing: normal;
  display: flex;
  align-items: center;

  .char-wrapper {
    position: relative;
  }

  .change-item-transition-enter-active,
  .change-item-transition-leave-active {
    transform: translateZ(0.1px);
    transition: all 0.3s ease;
    transition-property: transform, opacity;
    will-change: transform, opacity;
  }

  .change-item-transition-enter-active {
    position: relative;
    z-index: 1;
  }

  .change-item-transition-leave-active {
    position: absolute;
    right: 0;
  }

  .change-item-transition-enter-from {
    opacity: 1;
    transform: translateY(100%);
  }

  .change-item-transition-leave-to {
    opacity: 0;
    transform: translateY(-100%);
  }
}
</style>
